import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.jsx';
import './index.css';
import { maybeReloadForStaleChunk } from './lib/bootRecovery.js';

// Stale-chunk recovery lives in lib/bootRecovery.js — see there for why, and for why a
// suppressed reload now surfaces the boot card in index.html rather than a white page.
window.addEventListener('error', (ev) => maybeReloadForStaleChunk(ev.message));
window.addEventListener('unhandledrejection', (ev) => {
  maybeReloadForStaleChunk(ev.reason?.message ?? String(ev.reason));
});
// Vite's own signal for a failed module preload. Added 2026-07-27 after the two
// listeners above did NOT recover a real stale-chunk blank page: React Router
// owns the lazy import, so depending on how it surfaces the rejection the
// failure may never reach `error`/`unhandledrejection` at all. This event is
// emitted by Vite's preload helper itself, so it doesn't depend on the error
// escaping React or on matching a browser-specific message string.
window.addEventListener('vite:preloadError', (ev) => {
  ev.preventDefault?.();
  maybeReloadForStaleChunk('Failed to fetch dynamically imported module');
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
